import React from 'react';
import {getServerTexts} from './text';
import {SelectListModal} from './components/SelectListModal';

const selectListModalRef: React.RefObject<SelectListModal> = React.createRef();

export async function renderSelectListModal(root) {
    await getServerTexts();

    root.render(<SelectListModal ref={selectListModalRef} />);
    return selectListModalRef;
}
